import React from 'react';
import NotificationTreatmentItem from './NotificationTreatmentItem';
import NotificationCommonItem from './NotificationCommonItem';

const NotificationItem = (props) => {
  const { item } = props;

  switch (item.notification.type) {
    case 'treatmentInvitation':
      return <NotificationTreatmentItem {...props} />;
    case 'common':
      return <NotificationCommonItem {...props} />;
    default:
      return null;
  }
};

export default NotificationItem;
